import {SectionId, SECTIONS} from '../../../consts/Sections';
import {isCebiaWorkspace} from '../../../utils/isCebiaWorkspace';
import {isSectionActive} from '../../Section/utils/getActiveSections';

export function getVisibleSections(sections: string[], hiddenSections?: SectionId[]) {
  return SECTIONS.filter((section) => {
    if (isCebiaWorkspace()) {
      if (section.id === 'TESTDRIVE') {
        return true;
      }
    }
    return isSectionActive(section.id, sections) && !hiddenSections?.includes(section.id);
  });
}
